import { render, staticRenderFns } from "./entrada-formulario.vue?vue&type=template&id=5345ecc2"
import script from "./entrada-formulario.vue?vue&type=script&lang=js"
export * from "./entrada-formulario.vue?vue&type=script&lang=js"
import style0 from "./entrada-formulario.vue?vue&type=style&index=0&id=5345ecc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports